import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pyg-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
  standalone: false
})
export class NotFoundComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
